import { useAppSelector } from "app/redux-store-interactions";
import { selectMeasure } from "features/measure/measureSlice";

export function useDimensionData() {
    const {
        selectedEntities,
        duoMeasurementValues,
        currentIndex,
        loadingBrep: loading,
    } = useAppSelector(selectMeasure);

    const entities = selectedEntities[currentIndex] || [];
    const result = duoMeasurementValues.length > 0 ? duoMeasurementValues[currentIndex]?.result : undefined;
    const hasData = entities?.length > 0 || Boolean(result);
    const totalSets = selectedEntities.length;

    return {
        data: {
            entities,
            result,
            currentIndex,
            totalSets,
        },
        loading,
        error: null,
        hasData,
    };
}
